<script setup>
import { ref, onMounted } from 'vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-vue-next";
import { GetUser, UpdateUser } from "@/services/userService";
import { getContext } from "@/services/context";
import { useRoute, useRouter } from "vue-router";
import ErrorAlert from "@/components/ui/error-alert.vue";

const route = useRoute();

const isLoading = ref(false);
const email = ref(localStorage.getItem('email') || '');
const name = ref(localStorage.getItem('name') || '');
const error = ref(null);

onMounted(async () => {
  const context = getContext(route);

  isLoading.value = true

  try {
    const user = await GetUser(context);
    name.value = user.name;
    email.value = user.emailAddress;
  } catch (error) {
    console.error('Failed to get user:', error);
  } finally {
    isLoading.value = false;
  }
});

async function handleSubmit() {
  const context = getContext(route);
  isLoading.value = true;

  try {
    await UpdateUser(context, name.value, email.value);
  } catch (err) {
    error.value = err;
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <div class="container mx-auto pt-8">
    <Card class="w-full max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle class="text-2xl">Account Settings</CardTitle>
        <CardDescription>
          Manage your account settings and preferences.
        </CardDescription>
      </CardHeader>
      <CardContent class="space-y-4">
        <ErrorAlert v-if="error" :error="error" />
        <div class="space-y-2">
          <Label for="name">Name</Label>
          <Input id="name" v-model="name" placeholder="Your name" :disabled="isLoading" />
        </div>
        <div class="space-y-2">
          <Label for="email">Email</Label>
          <Input id="email" v-model="email" type="email" placeholder="Your email" :disabled="isLoading" />
        </div>
        <Button @click="handleSubmit" :disabled="isLoading" class="w-full">
          <Loader v-if="isLoading" class="mr-2 h-4 w-4 animate-spin" />
          Save Changes
        </Button>
      </CardContent>
    </Card>
  </div>
</template>